import { BusinessExternalService } from '@square/dashboard-protos/models/squareup/onboarding/business/external';
import rpc from '@square/dashboard-utilities/clients/rpc';
export default BusinessExternalService.create(rpc());